import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BriefcaseIcon, GraduationCapIcon, PresentationIcon, SmileIcon, UserIcon, BoxIcon } from "lucide-react";
import { audiences } from "../../data/home";
import { courses } from "../../data/courses";
import { CourseCard } from "../ui/CourseCard";
import { MockupTag } from "../ui/MockupTag";
const icons: Record<string, BoxIcon> = {
  adults: UserIcon,
  professionals: BriefcaseIcon,
  students: GraduationCapIcon,
  young: SmileIcon,
  teachers: PresentationIcon
};
export function AudienceFinder() {
  const [active, setActive] = useState(audiences[0].id);
  const current = audiences.find(audience => audience.id === active) ?? audiences[0];
  const matches = current.courses.map(slug => courses.find(course => course.slug === slug)).filter((course): course is NonNullable<typeof course> => Boolean(course));
  return <div data-id="element-418" data-mp="6rxnmvjo92y">
      <div role="tablist" aria-label="I am" className="flex gap-2 overflow-x-auto pb-2 [scrollbar-width:none]" data-id="element-419" data-mp="71mv88rmc7l">
        {audiences.map(audience => {
        const selected = audience.id === active;
        const Icon = icons[audience.id] ?? UserIcon;
        return <button key={audience.id} type="button" role="tab" id={`tab-${audience.id}`} aria-selected={selected} aria-controls={`panel-${audience.id}`} onClick={() => setActive(audience.id)} className={`inline-flex h-12 shrink-0 items-center gap-2 whitespace-nowrap rounded-[15px] border-2 px-4 type-button font-bold transition-colors duration-150 ${selected ? 'border-brand bg-white text-ink' : 'border-line bg-white text-body hover:border-muted hover:text-ink'}`} data-id="element-420" data-mp="2610zr4j2c98">
              <Icon className={`h-5 w-5 ${selected ? 'text-brand' : ''}`} aria-hidden="true" data-id="element-421" data-mp="3kcfexq2sqm7m" />
              {audience.label}
            </button>;
      })}
      </div>
      <AnimatePresence mode="wait" initial={false} data-id="element-422" data-mp="zokl0rdd6sj0">
        <motion.div key={current.id} id={`panel-${current.id}`} role="tabpanel" aria-labelledby={`tab-${current.id}`} initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -4
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-6 grid gap-5 lg:grid-cols-12" data-id="element-423" data-mp="zpvnmnv2pu8j">
          <div className="relative flex min-h-[320px] flex-col justify-end overflow-hidden rounded-[28px] p-6 lg:col-span-4" data-id="element-424" data-mp="outq1yufutm0">
            <img src={current.image} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-425" data-mp="3sddaif6vkv69" />
            <div className="absolute inset-0 bg-black/50" aria-hidden="true" data-id="element-426" data-mp="3nes766wbtvdl" />
            <MockupTag note="Placeholder image" className="absolute left-4 top-4" data-id="element-427" data-mp="3ncpd9bs1zi3l" />
            <p className="relative type-cta-title text-white" data-id="element-428" data-mp="604zwibcinqw">{current.text}</p>
          </div>
          <div className="grid gap-5 sm:grid-cols-2 lg:col-span-8 lg:grid-cols-3" data-id="element-429" data-mp="160pfp2vfxl2">
            {matches.map(course => <CourseCard key={course.slug} course={course} data-id="element-430" data-mp="39l0y0zmicdie" />)}
          </div>
        </motion.div>
      </AnimatePresence>
    </div>;
}